import React, { useContext, useEffect } from 'react';
import { Certification } from '../../models/Certification';
import { Context } from '../..';
import { Link } from 'react-router-dom';
import styles from './CertificationsPage.module.scss';

const CertificationsPage: React.FC = () => {
  const { store } = useContext(Context);
  const isAdmin = store.user?.role === 'admin';

  useEffect(() => {
    store.getCertifications();
  }, [store]);

  return (
    <div className={styles['certifications-page']}>
      <div className={styles['certifications-page__header']}>
        <h2 className={styles['certifications-page__title']}>Доступні сертифікації</h2>
        {isAdmin && (
          <Link to="/certifications/new" className={styles['certifications-page__create-btn']}>
            Створити сертифікат
          </Link>
        )}
      </div>
      <div className={styles['certifications-page__list']}>
        {store.certifications.length > 0 ? (
          store.certifications.map((cert: Certification) => (
            <Link key={cert.id} className={styles['certifications-page__item']} to={`/certifications/${cert.id}`}>
              <h3 className={styles['certifications-page__item-title']}>{cert.name}</h3>
              <p className={styles['certifications-page__item-description']}>ISO №{cert.ISO}</p>
              {cert.photo && (
                <img src={`${process.env.REACT_APP_BASE_URL}/images/${cert.photo}`} alt={cert.name} className={styles['certifications-page__item-img']} />
              )}
              <p className={styles['certifications-page__item-description']}>{cert.description}</p>
            </Link>
          ))
        ) : (
          <p className={styles['certifications-page__no-items']}>Сертифікації ще немає.</p>
        )}
      </div>
    </div>
  );
};

export default CertificationsPage;
